import { z } from 'zod';

const MAX_QUESTION_COUNT_ERROR_MESSAGE = 'เกินจำนวนที่มีในคลัง';

export const AddSingleQuestionConditionsSchema = z.object({
  contentType: z.enum(['TOPIC', 'LOS']),
  location: z.object({
    topics: z.record(z.string().uuid(), z.boolean().nullish()),
    subtopics: z.record(z.string().uuid(), z.boolean().nullish()),
  }),
  los: z.object(
    {
      label: z.string(),
      value: z.string(),
      inputValue: z.string().nullish(),
    },
    {
      message: 'กรุณาเลือก LOS',
    },
  ),
  questionType: createQuestionTypeSchemaByQuestionCount(),
  scorePerQuestion: z.number({
    message: 'กรุณากรอกคะแนนต่อข้อ',
  }),
});

export type AddSingleQuestionConditionsFormType = z.infer<typeof AddSingleQuestionConditionsSchema>;

export interface QuestionCountType {
  calculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
  notCalculated: {
    easy?: number;
    medium?: number;
    hard?: number;
  };
}

function createQuestionTypeByMaxCount(maxCount: number | undefined) {
  if (maxCount === undefined) {
    return z.number().int().nullish();
  }

  return z
    .union([
      z.literal(''),
      z.number().int().min(0).max(maxCount, { message: MAX_QUESTION_COUNT_ERROR_MESSAGE }),
    ])
    .transform((value) => {
      if (typeof value === 'string' && value === '') {
        return null;
      }
      return value;
    })
    .nullish();
}

export function createQuestionTypeSchemaByQuestionCount(questionCount?: QuestionCountType) {
  return z
    .object({
      calculated: z.object({
        easy: createQuestionTypeByMaxCount(questionCount?.calculated.easy),
        medium: createQuestionTypeByMaxCount(questionCount?.calculated.medium),
        hard: createQuestionTypeByMaxCount(questionCount?.calculated.hard),
      }),
      notCalculated: z.object({
        easy: createQuestionTypeByMaxCount(questionCount?.notCalculated.easy),
        medium: createQuestionTypeByMaxCount(questionCount?.notCalculated.medium),
        hard: createQuestionTypeByMaxCount(questionCount?.notCalculated.hard),
      }),
    })
    .refine(
      (value) => {
        const { calculated, notCalculated } = value;
        const calculatedTotal = Object.values(calculated).reduce(
          (sum: number, count) => sum + (count ?? 0),
          0,
        );
        const notCalculatedTotal = Object.values(notCalculated).reduce(
          (sum: number, count) => sum + (count ?? 0),
          0,
        );

        return calculatedTotal + notCalculatedTotal > 0;
      },
      {
        message: 'กรุณากรอกจำนวนข้ออย่างน้อย 1 ข้อ',
      },
    );
}
